// extracted by mini-css-extract-plugin
module.exports = {"SignupForm":"SignupForm___Hw7_7","ButtonContainer":"ButtonContainer___xSjDR","Unsubscribe":"Unsubscribe___2CMqq","loading":"loading___PybFm"};